import React from 'react';
export function Footer() {
  return <footer className="bg-black text-zinc-400 py-12 border-t border-emerald-900/40" data-id="element-122">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-123">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-124">
          🇧🇷 MEGAPACK PORTUGUÉS LISTO™
        </h4>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-125">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-emerald-400 transition-colors" data-id="element-126">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-127">·</span>
          <span className="hover:text-emerald-400 transition-colors" data-id="element-128">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-zinc-600 border-t border-zinc-800 pt-8 space-y-3" data-id="element-129">
          <p data-id="element-130">
            © MEGAPACK PORTUGUÉS LISTO™ 2026 — Todos los derechos reservados.
          </p>
          <p className="italic text-emerald-300/80" data-id="element-131">
            🇧🇷🇦🇷 "La próxima vez que un brasileño te escriba, vas a saber
            exactamente qué responder — en portugués real."
          </p>
        </div>
      </div>
    </footer>;
}